export const css = {
    root: '_2StaMn79',
    loading: '_1SNzFv6K',
    instructions: '_19sOpiBh',
    timerblock: '_2Ei2oEz7',
    timer: '_7uxKLpOQ',
    timerNegative: '_3mXB7Fta',
    actions: 'O2jO4CUw',
    oneaction: '_2fuMupMA',
    score: '_1XgZW7FI',
    scoreTitle: '_1oGLVe5O',
    scorePercent: '_2vwSBGw4',
    actionIcon: '_2ZQopZhO',
    primaryButton: '_3svbNBWo',
    secondaryButton: '_1czXqaw6',
    microQuizWrapper: '_1mINdwwp',
    microQuizHeader: '_1ZA8e0x3',
    passed_instructions: '_3CxDGSUi',
    ' _key': 'quiz-widgets/prometric'
};
export default css;
